import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GridPattern from "./components/GridPattern";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Location from "./components/Location";
import Artists from "./components/Artists";
import FacebookSection from "./components/FacebookSection";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LaserRemoval from "./components/LaserRemoval";
import JerryGallery from "./components/JerryGallery";
import Shop from "./components/Shop";
import ThankYou from "./components/ThankYou";
import VoucherTeaser from "./components/VoucherTeaser";
import JoniGallery from "./components/JoniGallery";
import JosieGallery from "./components/JosieGallery";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <div className="relative bg-black min-h-screen">
      <GridPattern />
      <Navbar />
      <Hero />
      <Location />
      <Artists />
      <FacebookSection />
      <Services />
      <VoucherTeaser />
      <FAQ />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/laser-removal" element={<LaserRemoval />} />
          <Route path="/jerry-gallery" element={<JerryGallery />} />
          <Route path="/joni-gallery" element={<JoniGallery />} />
          <Route path="/josie-gallery" element={<JosieGallery />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
